import { DashboardActivityLog } from "./DashboardActivityLog";
import { Welcome } from "./Welcome";
import MobileHeader from "../layout/MobileHeader";
import { NotificationsMenu } from "../notifications/NotificationsMenu";
import { MobileContent } from "../layout/MobileContent";
import { useConfigurationContext } from "../root/ConfigurationContext";

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const { darkModeLogo, lightModeLogo, title } = useConfigurationContext();
  return (
    <>
      <MobileHeader>
        <div className="flex items-center gap-2 text-secondary-foreground no-underline py-3">
          <img
            className="[.light_&]:hidden h-6"
            src={darkModeLogo}
            alt={title}
          />
          <img
            className="[.dark_&]:hidden h-6"
            src={lightModeLogo}
            alt={title}
          />
          <h1 className="text-xl font-semibold">{title}</h1>
        </div>
        {/* MobileHeader is a shell each page fills, so there is no one place
            for a global bell. The dashboard is where a mobile user lands, so
            it lives here until the mobile shell grows a shared slot. */}
        <NotificationsMenu />
      </MobileHeader>
      <MobileContent>{children}</MobileContent>
    </>
  );
};

export const MobileDashboard = () => {
  // Same as the desktop dashboard: no first-run checklist on an installed hub.
  // It reappeared whenever contacts or notes were near zero, which after a
  // database clean describes a hub in daily use, and on a phone it replaced the
  // entire screen rather than sitting above it.
  return (
    <Wrapper>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mt-1">
        {import.meta.env.VITE_IS_DEMO === "true" ? <Welcome /> : null}
        <DashboardActivityLog />
      </div>
    </Wrapper>
  );
};
